export default {
  default: {
    formFieldLabels: {
      unassigned: 'Unassigned',
    },
  },
}
